export default "__VITE_ASSET___vJY6cNu__"